export default __webpack_public_path__ + "static/media/JULD.bebac952.png";